
import React, { PureComponent } from 'react';

import ChatMessage from './ChatMessage';

type Props = {

  /**
   * Additional CSS classes to apply to the root element.
   */
  className: string,

  /**
   * The messages to display as a group.
   */
  messages: Array<Object>,
};

/**
 * Displays a list of chat messages. Will show only the display name for the
 * first chat message and the timestamp for the last chat message.
 *
 * PureComponent: the parent memoizes grouping by the message-list reference, so a group's
 * {@code messages} prop keeps a stable reference across the frequent re-renders caused by local
 * scroll/badge state. This lets React skip re-rendering (and re-building the avatar map) for every
 * group on every scroll tick - only groups whose messages actually changed re-render.
 *
 * @augments React.PureComponent
 */
class ChatMessageGroup extends PureComponent<Props> {
    static defaultProps = {
        className: ''
    };

    /**
   * Implements React's {@link Component#render()}.
   *
   * @inheritdoc
   */
    render() {
        const { className, messages } = this.props;
        const avatarData = APP.store.getState()['features/base/participants'];
        const messagesLength = messages.length;
        const _avatarURLs = {};

        avatarData.forEach(avatar => {
            const avatarID = avatar.id;

            _avatarURLs[avatarID] = avatar.avatarURL;
        });

        if (!messagesLength) {
            return null;
        }

        return (
            <div className = { `chat-message-group ${className}` }>
                {messages.map((message, i) => (
                    <ChatMessage
                        avatarURLs = { _avatarURLs }
                        dispatch = { this.props.dispatch }
                        key = { i }
                        message = { message }
                        showDisplayName = { i === 0 }
                        showTimestamp = { i === messages.length - 1 } />
                ))}
            </div>
        );
    }
}

export default ChatMessageGroup;
